import { type FC } from 'react';
import AppStoreDark from 'dibs-icons/exports/legacy/AppStoreDark.ts';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { useNavContext } from '../../NavContext.tsx';
import { userServerVars } from '../../userServerVars.ts';

import styles from './styles/NavLogoutDownloadSellerApp.module.css';
import classNames from 'classnames';
import dibsCss from 'dibs-css';

const appStoreLink = 'https://dibsdealer.onelink.me/ZglY/v6h5eeee';

export const NavLogoutDownloadSellerApp: FC = () => {
    const { isDealer } = userServerVars;
    const { status } = useNavContext();

    if (status === 'collapsed') {
        return null;
    }

    return (
        <div
            className={classNames(
                dibsCss.flex,
                dibsCss.flexCol,
                dibsCss.gapSmall,
                dibsCss.mxSmall,
                dibsCss.mtXsmall,
                dibsCss.pxXsmall,
                dibsCss.pySmall,
                dibsCss.border0,
                dibsCss.borderT,
                dibsCss.borderSolid,
                dibsCss.borderDolphin
            )}
        >
            <Link href={`/logout/${isDealer ? 'dealer' : 'internal'}`} dataTn="logout-link">
                <span
                    className={classNames(dibsCss.sassyFontBodyMediumHeavy, {
                        [dibsCss.textSatan]: isDealer,
                        [dibsCss.textWhite]: !isDealer,
                    })}
                >
                    <FormattedMessage
                        id="dal.header.userMenuOptions.logout"
                        defaultMessage="Logout"
                    />
                </span>
            </Link>
            {isDealer && (
                <>
                    <Link href={appStoreLink} target="_blank" dataTn="download-seller-app-link">
                        <span
                            className={classNames(
                                dibsCss.textSatan,
                                dibsCss.sassyFontBodyMediumHeavy
                            )}
                        >
                            <FormattedMessage
                                id="dal.header.userMenuOptions.downloadSellerApp"
                                defaultMessage="Download Seller App"
                            />
                        </span>
                    </Link>
                    <Link href={appStoreLink} target="_blank" dataTn="download-seller-app-icon">
                        <AppStoreDark className={classNames(dibsCss.hLarge, styles.appStoreIcon)} />
                    </Link>
                </>
            )}
        </div>
    );
};
